import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@material-ui/core";
import { IconLogout, IconUserCircle } from "@tabler/icons-react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import React from "react";
import { resetState } from "../slices/auth/authSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: "visible",
    marginTop: 40,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      marginLeft: -0.5,
      marginRight: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
}));

const ProfileActionsButtons = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const classes = useStyles();
  const theme = useTheme();

  const handleLogout = () => {
    dispatch(resetState());
    localStorage.clear();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        endIcon={<IconUserCircle color={theme.palette.primary.light} />}
        style={{
          borderRadius: "2rem",
        }}
      >
        <Typography
          variant="body1"
          style={{
            textTransform: "capitalize",
            color: theme.palette.primary.main,
            fontWeight: 500,
          }}
        >
          {userInfo?.nombre}
        </Typography>
      </Button>
      <Menu
        variant="menu"
        elevation={0}
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 1,
          className: classes.paper,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/*  <MenuItem onClick={handleClose}>
          <Typography>
            <span>Perfil:</span>
            {userInfo?.perfil === "1" ? "Administrador" : "Cliente"}
          </Typography>
        </MenuItem>
        <Divider /> */}
        {/* <MenuItem onClick={handleClose}>
          <Avatar /> My account
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
        <MenuItem onClick={handleLogout}>
          <ListItem>
            <ListItemIcon>
              <IconLogout />
            </ListItemIcon>
            <ListItemText>Cerrar Sesión</ListItemText>
          </ListItem>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileActionsButtons;
